
import { supabase } from "@/integrations/supabase/client";
import { BaseApiClient } from "../../baseApiClient";
import { logger } from "@/lib/logger";
import { BusinessData, BUSINESS_INDUSTRIES, BusinessIndustry } from "../types";
import { businessMapper } from "../mappers";

/**
 * Updates a business profile
 */
export async function updateBusiness(
  businessId: string, 
  businessData: Partial<BusinessData>
): Promise<BusinessData | null> {
  // Make sure industry_enum is a valid enum value
  if (businessData.industry_enum && 
      !BUSINESS_INDUSTRIES.includes(businessData.industry_enum as BusinessIndustry)) {
    businessData.industry_enum = undefined;
  }
  
  // Convert frontend data to database format
  const supabaseData = businessMapper.toDb(businessData as BusinessData);
  
  return BaseApiClient.request<BusinessData | null>(
    `business:update:${businessId}`,
    async () => {
      try {
        const { data, error } = await supabase
          .from('business')
          .update(supabaseData)
          .eq('id', businessId)
          .select()
          .single();
        
        if (error) {
          throw new Error(`Failed to update business: ${error.message}`);
        }
        
        // Clear cache for related queries
        BaseApiClient.clearCache(`business:${businessId}`);
        
        // Convert response data to frontend format
        return businessMapper.toFrontend(data);
      } catch (error) {
        logger.error({
          message: "Error updating business",
          error: error instanceof Error ? error : new Error(String(error)),
          context: { businessId, businessData }
        });
        throw error;
      }
    }
  );
}
